<div class="dialog-container">
  <div class="header-section mx-auto">
    <p class="expense-title">Add a Note</p>
    <button type="button" class="close add-close-button" data-dismiss="modal" (click)="closeDialog()">
      <span class="material-icons icons-close-mobile">close</span>
    </button>
  </div>
  <hr class="m-0 p-0" />

  <!-- <form class="mx-auto w-[90%] mt-5">
    <textarea
      #textarea
      matInput
      placeholder="Add your note here..."
      class="full-width"
      rows="4"
      [(ngModel)]="note"
      maxlength="200"
      [value]="note ? note : ''"
      (input)="checkNote($event.target.value)"
    >
    </textarea>
  </form> -->

  <div class="mx-auto w-[90%] mt-5">
    <mat-form-field
      class="automtic-form-desing-form-only app__medium--height--form app__hidden--subscript--wrapper w-full"
      [ngClass]="'add-automtic-form-desing'"
      appearance="fill"
      floatLabel="'always'"
    >
      <mat-label class="automtic-form-desing-lable"> Title </mat-label>
      <input
        matInput
        type="text"
        maxlength="50"
        placeholder="Notes"
        [(ngModel)]="noteTitle"
        (focus)="selectAllContent($event)"
        (keydown)="disableWhiteSpaceOnFirstCharacter($event)"
        (input)="handleInput($event)"
        required
      />
    </mat-form-field>
    <div class="editor mt-4">
      <div class="editor__menu">
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
      </div>
      <ngx-editor
        class="w-full"
        [editor]="editor"
        [(ngModel)]="note"
        (ngModelChange)="onContentChange($event)"
        (keydown)="onKeyDown($event)"
        [placeholder]="'Add notes here...'"
      >
      </ngx-editor>
    </div>
  </div>
  <span id="note-count">{{ noteContentCount + ' / ' + maxChars }}</span>
  <hr class="m-0 p-0" />

  <div class="w-[90%] flex justify-end items-center mx-auto border-t-0 mt-3">
    <!-- <div class="flex">
      <mat-slide-toggle
        class="app__form--attribute--title font-normal text-sm text-[#515765] margin-zero"
        [(ngModel)]="data.noteCompletionValue"
        (change)="onToggleChange($event)"
      >
        I don’t want to add a note
      </mat-slide-toggle>
    </div> -->
    <button
      mat-raised-button
      type="submit"
      [disabled]="note == '' || noteTitle == '' || !noteContentCount"
      [class]="
        note != '' && noteTitle != '' && noteContentCount
          ? 'app__btn--primary w-[86px] sm:py-[6px] py-[6px] px-3 m-0 rounded'
          : 'app__btn--disabled w-[86px] sm:py-[6px] py-[6px] px-3 m-0 rounded'
      "
      (click)="data.isEditing ? editNote() : addNote()"
    >
      {{ data?.isEditing ? 'Update' : 'Save' }}
    </button>
  </div>
</div>
